import React from 'react';
import { Col } from 'react-bootstrap';

class rateList extends React.Component {
  state = {
    search: '',
    idRate: -1,
  };

  componentDidMount() {
    if (this.props.rates && this.props.setRate) {
      this.props.setRate({});
    }
  }

  onSearch = (e) => {
    this.setState({ search: e.target.value });
  };

  getRateLabel = (rate) => {
    if (!rate.shortname) {
      return rate.name;
    }
    return `(${rate.shortname}) ${rate.name}`;
  };

  getSearchRates = () => {
    let { rates } = this.props;

    if (this.state.search !== '') {
      const search = this.state.search.toLowerCase();
      rates = rates.filter((r) => {
        if (r.id !== 0) {
          return (
            r.name.toLowerCase().includes(search) ||
            r.shortname.toLowerCase().includes(search)
          );
        }
        return null;
      });
    }
    rates = rates.sort((a, b) => a.shortname - b.shortname);
    return rates;
  };

  handleClickRate(rate) {
    this.setState({ idRate: rate.id });
    this.props.setRate(rate);
    this.props.getNotifications(rate.id);
  }

  renderSearch(search) {
    return (
      <Col>
        <div className="searchInput">
          <input
            id="input"
            className="form-control"
            value={search}
            onChange={this.onSearch}
          />
          {search !== '' ? (
            <i
              onClick={() => this.setState({ search: '' })}
              className="fa fa-close fa-lg fa-close"
            />
          ) : (
            <i className="fa fa-search fa-lg fa-in-search" />
          )}
        </div>
      </Col>
    );
  }

  render() {
    const filteredRate = this.getSearchRates();

    return (
      <div>
        <div className="searchContainer">
          <div>{this.renderSearch(this.state.search)}</div>
        </div>
        <div className="rate-name-list">
          {filteredRate.length > 0 ? (
            filteredRate.map((rate) => (
              <div key={rate.id}>
                <div
                  onClick={() => this.handleClickRate(rate)}
                  className={
                    rate.id === this.state.idRate
                      ? 'rate-title active'
                      : 'rate-title'
                  }
                >
                  <div>{this.getRateLabel(rate)}</div>
                  {rate.notifications !== null &&
                    rate.notifications !== undefined && (
                      <div>
                        <i className="fa fa-bell fa-lg" />
                      </div>
                    )}
                </div>
              </div>
            ))
          ) : (
            <p>No AFSCs</p>
          )}
        </div>
      </div>
    );
  }
}

export default rateList;
